<template>
  <div>
    <Error_messages
      :error_message="messages.error"
      :success_message="messages.success"
    />
    <div class=" d-flex justify-content-center mb-1">
      <vue-dropzone
        ref="myVueDropzone"
        id="dropzone"
        class=""
        v-on:vdropzone-success="uploadSuccess"
        :vdropzone-error="uploadError"
        v-on:vdropzone-removed-file="fileRemoved"
        :options="dropzoneOptions"
      ></vue-dropzone>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { UPLOAD_URL } from "@/config/API";
import { MAX_UPLOAD_FILE_SIZE } from "@/config/AppConfig";
import { commonHeaders } from "@/Utils/$http";
import { deleteMedia } from "@/API/MediaAPIs";
import Error_messages from "@/helpers/error_messages.vue";
import * as _ from "lodash";
export default {
  name: "FileUpload",
  components: {
    vueDropzone: vue2Dropzone,
    Error_messages
  },
  props: ["value", "multiple", "field"],
  data() {
    return {
      count: 0,
      menu: [],
      loading: false,
      is_destroying: false,
      dropzoneOptions: {
        url: UPLOAD_URL,
        parallelUploads: 1,

        maxFilesize: MAX_UPLOAD_FILE_SIZE,
        acceptedFiles: "image/*",
        thumbnailHeight: 138,
        addRemoveLinks: true,
        headers: commonHeaders,
        dictDefaultMessage: ` <div data-icon='0' class='icon'> ${this
          .field?.placeholder || "DROP YOUR IMAGES HERE"} </div> `,

        destroyDropzone: false
      },
      mediaFiles: [],
      messages: { error: "", success: "" }
    };
  },

  methods: {
    uploadSuccess(file) {
      var src = encodeURI(this.getFileSrc(file));
      this.addMedia({ id: null, src: src });
    },
    getFileSrc(file) {
      return JSON.parse(file.xhr.response).file || false;
    },
    uploadError(error) {
      console.log("An Error Occurred", error);
    },
    addMedia(m) {
      this.mediaFiles.push({ id: m.id, src: m.src });

      this.manuallyAddImage(m.src);
      this.$emit("input", this.mediaFiles);
    },
    async fileRemoved(file) {
      setTimeout(async () => {
        if (this.is_destroying) {
          let mediaFiles = JSON.parse(JSON.stringify(this.mediaFiles));
          if (file.xhr) {
            let uploadedLink = this.getFileSrc(file);
            _.remove(mediaFiles, media => media.src === uploadedLink);
          } else {
            let media = mediaFiles.filter(media => media.src === file.name)[0];
            if (media) {
              let confirm = await this.deleteMedia(media);
              if (confirm) {
                _.remove(mediaFiles, media => media.src === file.name);
                this.$emit("updated");
              } else this.addMedia(media);
            }
          }
          this.mediaFiles = mediaFiles;
          this.$emit("input", this.mediaFiles);
          this.is_destroying = false;
        }
      }, 100);
    },
    async manuallyAddImage(imageUrl) {
      const options = { size: 123, name: imageUrl, type: "image/png" };
      this.$refs.myVueDropzone.manuallyAddFile(options, imageUrl);
    },
    async deleteMedia(media) {
      const isConfirmed = await new Promise(resolve => {
        this.$bvModal
          .msgBoxConfirm("Are you sure you want to delete this item?", {
            title: "Confirm Delete",
            okTitle: "Yes, Delete",
            cancelTitle: "Cancel",
            okVariant: "danger",
            centered: true
          })
          .then(confirmed => {
            resolve(confirmed);
          });
      });

      if (isConfirmed) {
        if (media.id) await deleteMedia(media.id);
        this.messages.success = "Deleted successfully";
        setTimeout(() => {
          this.messages.success = "";
        }, 2000);
        return true;
      }
      return false;
    },
    listenDestroying() {
      const buttons = document.querySelectorAll(".dz-remove");
      buttons.forEach(button => {
        button.addEventListener("click", () => {
          this.is_destroying = true;
        });
      });
    }
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      this.$nextTick(() => {
        this.$refs.myVueDropzone.removeAllFiles();
        this.mediaFiles = [];

        this.value.forEach(media => {
          this.addMedia(media);
        });

        this.listenDestroying();
      });
    }
  },
  watch: {
    value: {
      deep: true,

      handler(media, mediaOld) {
        if (!media) return;
        if (JSON.stringify(media) === JSON.stringify(mediaOld)) return;
        this.count++;
        if (this.count < 1000) {
          this.mediaFiles = [];
          this.$refs.myVueDropzone.removeAllFiles();
          media.map(m => this.addMedia(m));
          this.listenDestroying();
        } else {
          console.error("dead lock fileUpload");
        }
      }
    }
  }
};
</script>
<style>
#dropzone {
  text-align: center;

  width: 100%;
}
</style>
